// Locale-aware formatting. Money is ALWAYS integer minor units + a currency code
// (never a bare number). The currency code is shown explicitly (design-system-mapping).
import type { Currency } from "@retirement-planner/contract";

type Locale = "th" | "en";

const LOCALE_TAG: Record<Locale, string> = { th: "th-TH", en: "en-US" };

/** Format integer minor units (satang/cents) as a currency string with an explicit code. */
export function formatMoney(amountMinorUnits: number, currency: Currency, locale: Locale): string {
  const major = amountMinorUnits / 100;
  return new Intl.NumberFormat(LOCALE_TAG[locale], {
    style: "currency",
    currency,
    currencyDisplay: "code", // e.g. "THB 4,200,000.00" — explicit code, never a bare number
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(major);
}

/** Format a whole-number percent (6.0 => "6%"). */
export function formatPercent(pct: number, locale: Locale): string {
  return new Intl.NumberFormat(LOCALE_TAG[locale], {
    style: "percent",
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  }).format(pct / 100);
}

/** Format a probability 0..1 as a whole percent ("0.85" => "85%"). */
export function formatProbability(p: number, locale: Locale): string {
  return new Intl.NumberFormat(LOCALE_TAG[locale], {
    style: "percent",
    maximumFractionDigits: 0,
  }).format(p);
}
